export default __webpack_public_path__ + "static/media/hotel05.211942c8.png";